// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IframeAdapter__iframe--Oo","hidden":"IframeAdapter__hidden--y3"};